import React from "react";

function PaymentIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="16"
      viewBox="0 0 19 16"
      fill="none"
    >
      <g clip-path="url(#clip0_1388_2185)">
        <path
          d="M2.1875 1C1.08438 1 0.1875 1.89688 0.1875 3V4H18.1875V3C18.1875 1.89688 17.2906 1 16.1875 1H2.1875ZM18.1875 7H0.1875V13C0.1875 14.1031 1.08438 15 2.1875 15H16.1875C17.2906 15 18.1875 14.1031 18.1875 13V7ZM3.6875 11H5.6875C5.9625 11 6.1875 11.225 6.1875 11.5C6.1875 11.775 5.9625 12 5.6875 12H3.6875C3.4125 12 3.1875 11.775 3.1875 11.5C3.1875 11.225 3.4125 11 3.6875 11ZM7.1875 11.5C7.1875 11.225 7.4125 11 7.6875 11H11.6875C11.9625 11 12.1875 11.225 12.1875 11.5C12.1875 11.775 11.9625 12 11.6875 12H7.6875C7.4125 12 7.1875 11.775 7.1875 11.5Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1388_2185">
          <path d="M0.1875 0H18.1875V16H0.1875V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default PaymentIcon;
